import { Toast } from 'mint-ui'
import "mint-ui/lib/toast/style.css"

export default function Tip(message, callback,res) {
  if(!message) return
  Toast({
    message,
    duration: 2000
  })
  setTimeout(() => callback && callback(res), 2000)
}